import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from "@/components/uploadImagetow";
import { itemTypeList } from "@/api/gmtool/packageCode";
import { mapState } from "vuex";
import { szgmSendEmail, szgmdoSend } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewCom, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom, gmToolNewPage],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      type: 0,
      paramsData: {
        type: "to_users",
        method: "",
        title: "",
        context: "",
        reward: [],
        server_channel: "",
        server_show_test: "",
        server_id: [],
        serverData: [],
        sender: "",
        language: "",
        delay_time: "",
        id: "",
        uids: "",
        delay_state: 2,
        expire: null
      },
      dialogShow: false,
      emailType: [{
        label: this.$t('allPlayers'),
        value: "all"
      }, {
        label: this.$t('selectedPlayers'),
        value: "to_users"
      }],
      timing: [{
        label: this.$t('no'),
        value: 2
      }, {
        label: this.$t('yes'),
        value: 1
      }],
      timingType: 2,
      currencyItemList: [],
      equipmentItemList: [],
      itemType: [],
      rules: {
        sender: [{
          required: true,
          message: this.$t('pleaseEnterSender'),
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: this.$t('pleaseEnterTitle'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        context: [{
          required: true,
          message: this.$t('pleaseEnterContent'),
          trigger: "blur"
        }],
        expire: [{
          required: true,
          message: this.$t('pleaseSelectExpireTime'),
          trigger: "blur"
        }],
        delay_time: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        uids: [{
          required: true,
          validator: validateuids,
          trigger: "blur"
        }],
        item_type: [{
          required: true,
          message: this.$t('pleaseSelectItemType'),
          trigger: "blur"
        }],
        id: [{
          required: true,
          message: this.$t('pleaseSelectItem'),
          trigger: "blur"
        }],
        item_num: [{
          required: true,
          message: this.$t('pleaseEnterQuantity'),
          trigger: "blur"
        }],
        item_quality: [{
          required: true,
          message: this.$t('pleaseSelectItemQuality'),
          trigger: "blur"
        }],
        textid: [{
          required: true,
          message: this.$t('itemId'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        star: [{
          required: true,
          message: this.$t('pleaseEnterStar'),
          trigger: "blur"
        }],
        ext: [{
          required: true,
          message: this.$t('pleaseEnterExt'),
          trigger: "blur"
        }]
      },
      isSend: false,
      isPermissions: false
    };
  },
  watch: {
    serverListYJ: {
      handler: function handler(newVal) {
        if (newVal && newVal.length > 0) {
          if (this.paramsData.server_id.length == this.serverListYJ.length) {
            this.checked = true;
          } else {
            this.checked = false;
          }
        }
      },
      immediate: true
    }
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    getTypeList: function getTypeList() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        itemTypeList({
          page_size: -1
        }).then(function (res) {
          if (res.code == 200) {
            _this2.itemType = res.data.map(function (item) {
              return {
                label: item.name,
                value: item.type_id
              };
            });
            resolve(_this2.itemType);
          } else {
            reject(new Error('获取物品类型列表失败'));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    openWithServerChannel: function openWithServerChannel(serverChannel, data, uids) {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isPermissions, d, server_idList, uidsList, k, _server_idList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isPermissions = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : false;
                _this3.serverChannel = serverChannel;
                _context.next = 4;
                return _this3.getTypeList();

              case 4:
                _this3.itemType.map(function (i) {
                  _this3['itemType' + i.value] = _this3.szgmItemList.filter(function (item) {
                    return item.type == i.value;
                  });
                });

                d = {
                  method: "",
                  id: data.id || "",
                  title: data.title || "",
                  context: data.content || "",
                  reward: [],
                  serverData: [],
                  server_id: [],
                  server_channel: "",
                  server_show_test: "",
                  sender: data.sender,
                  language: data.language,
                  delay_time: data.delay_time ? data.delay_time : null,
                  type: data.email_type !== 0 ? data.email_type == 1 ? "all" : "to_users" : "",
                  uids: '',
                  expire: data.expire,
                  delay_state: data.delay_state
                };
                _this3.server_channel = data.server_channel || '';
                _this3.show_test = data.server_show_test ? parseInt(data.server_show_test) : '';

                if (_this3.server_channel && _this3.show_test !== '') {
                  _this3.serverChannelChange(false);
                }

                if (d.delay_state == 1 && d.type == 'to_users') {
                  server_idList = data.server_id.split(',');

                  if (server_idList.length > 1) {
                    uidsList = data.email_user_ids;

                    for (k in uidsList) {
                      d.server_id.push(parseInt(k));
                      d.serverData.push({
                        label: parseInt(k),
                        value: uidsList[k].toString()
                      });
                    }
                  } else {
                    d.server_id = [parseInt(server_idList[0])];
                    d.serverData.push({
                      label: parseInt(server_idList[0]),
                      value: data.email_user_ids
                    });
                  }
                } else if (d.delay_state == 1 && d.type == 'all') {
                  _server_idList = data.server_id.split(',');
                  d.server_id = _server_idList.map(function (i) {
                    return parseInt(i);
                  });
                }

                d.reward = data.reward ? JSON.parse(data.reward) : [];
                d.reward.map(function (item) {
                  var str = JSON.stringify(item.id);

                  var index = _this3.szgmItemList.findIndex(function (j) {
                    return j.id == str;
                  });

                  item.id = index > -1 ? str : '';
                  item.textid = index > -1 ? '' : str;
                  item.type = index > -1 ? Number(_this3.szgmItemList[index].type) : item.type;

                  if (item.ext) {
                    item.ext = item.ext[0];
                  }
                });
                _this3.paramsData = _objectSpread(_objectSpread({}, _this3.paramsData), d);

                if (uids) {
                  _this3.isSend = uids ? true : false;
                  _this3.paramsData.type = uids ? "to_users" : "all";
                  _this3.paramsData.uids = uids;
                }

                _this3.dialogShow = true;
                _this3.isPermissions = isPermissions;

                if (isPermissions) {
                  _this3.paramsData.type = _this3.emailType[1].value;
                  _this3.paramsData.reward = [];
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    open: function open(data, uids) {
      var _arguments2 = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isPermissions, d, server_idList, uidsList, k, _server_idList2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isPermissions = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : false;
                _context2.next = 3;
                return _this4.getTypeList();

              case 3:
                _this4.itemType.map(function (i) {
                  _this4['itemType' + i.value] = _this4.szgmItemList.filter(function (item) {
                    return item.type == i.value;
                  });
                });

                d = {
                  method: "",
                  id: data.id || "",
                  title: data.title || "",
                  context: data.content || "",
                  reward: [],
                  serverData: [],
                  server_id: [],
                  server_channel: "",
                  server_show_test: "",
                  sender: data.sender,
                  language: data.language,
                  delay_time: data.delay_time ? data.delay_time : null,
                  type: data.email_type !== 0 ? data.email_type == 1 ? "all" : "to_users" : "",
                  uids: '',
                  expire: data.expire,
                  delay_state: data.delay_state
                };
                _this4.server_channel = data.server_channel || '';
                _this4.show_test = data.server_show_test ? parseInt(data.server_show_test) : '';

                if (_this4.server_channel && _this4.show_test !== '') {
                  _this4.serverChannelChange(false);
                }

                if (d.delay_state == 1 && d.type == 'to_users') {
                  server_idList = data.server_id.split(',');

                  if (server_idList.length > 1) {
                    uidsList = data.email_user_ids;

                    for (k in uidsList) {
                      d.server_id.push(parseInt(k));
                      d.serverData.push({
                        label: parseInt(k),
                        value: uidsList[k].toString()
                      });
                    }
                  } else {
                    d.server_id = [parseInt(server_idList[0])];
                    d.serverData.push({
                      label: parseInt(server_idList[0]),
                      value: data.email_user_ids
                    });
                  }
                } else if (d.delay_state == 1 && d.type == 'all') {
                  _server_idList2 = data.server_id.split(',');
                  d.server_id = _server_idList2.map(function (i) {
                    return parseInt(i);
                  });
                }

                d.reward = data.reward ? JSON.parse(data.reward) : [];
                d.reward.map(function (item) {
                  var str = JSON.stringify(item.id);

                  var index = _this4.szgmItemList.findIndex(function (j) {
                    return j.id == str;
                  });

                  item.id = index > -1 ? str : '';
                  item.textid = index > -1 ? '' : str;
                  item.type = index > -1 ? Number(_this4.szgmItemList[index].type) : item.type;

                  if (item.ext) {
                    item.ext = item.ext[0];
                  }
                });
                _this4.paramsData = _objectSpread(_objectSpread({}, _this4.paramsData), d);

                if (uids) {
                  _this4.isSend = uids ? true : false;
                  _this4.paramsData.type = uids ? "to_users" : "all";
                  _this4.paramsData.uids = uids;
                }

                _this4.dialogShow = true;
                _this4.isPermissions = isPermissions;

                if (isPermissions) {
                  _this4.paramsData.type = _this4.emailType[1].value;
                  _this4.paramsData.reward = [];
                }

                if (_this4.isMobile) {
                  setTimeout(function () {
                    var dialogs = document.querySelectorAll('.dialogs');
                    dialogs.forEach(function (dialog) {
                      dialog.style.paddingTop = '0';
                      dialog.style.paddingBottom = '0';
                    });
                  }, 100);
                }

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        method: "",
        id: isClearId ? "" : this.paramsData.id,
        title: "",
        context: "",
        reward: [],
        sender: "",
        server_channel: "",
        server_show_test: "",
        serverData: [],
        server_id: [],
        language: "",
        delay_time: "",
        delay_state: isClearId ? 2 : this.paramsData.delay_state,
        type: this.isSend || this.isPermissions ? "to_users" : "all",
        uids: this.isSend ? this.paramsData.uids : "",
        expire: this.$times.timestampToTime((new Date(this.$times.zeroTimeZone()).getTime() + 3600 * 1000 * 24 * 7) / 1000, "YY-MM-DD HH:II:SS")
      };
      this.server_channel = '';
      this.show_test = '';
      this.serverListYJ = [];
      this.$refs.ruleForm.clearValidate();
    },
    delayStateChange: function delayStateChange() {
      if (!this.isSend) {
        this.paramsData.uids = '';
      }

      this.paramsData.type = "to_users";
      this.paramsData.expire = '';
      this.paramsData.delay_time = '';
    },
    serverIdChange: function serverIdChange(e) {
      var _this5 = this;

      this.paramsData.serverData = [];
      e.forEach(function (i) {
        _this5.paramsData.serverData.push({
          label: i,
          value: _this5.isSend || _this5.isPermissions ? _this5.paramsData.uids : ''
        });
      });

      if (e.length === this.serverListYJ.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    selectAll: function selectAll() {
      var _this6 = this;

      this.paramsData.server_id = [];
      this.paramsData.serverData = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this6.paramsData.server_id.push(item.serverID);
        });
        this.serverListYJ.forEach(function (i) {
          _this6.paramsData.serverData.push({
            label: i.serverID,
            value: _this6.isSend || _this6.isPermissions ? _this6.paramsData.uids : ''
          });
        });
      } else {
        this.paramsData.server_id = [];
      }
    },
    fileUp: function fileUp(e, index) {
      this.paramsData.serverData[index].value = e.data.toString();
    },
    itemChange: function itemChange(index, type) {
      this.paramsData.reward[index][type == 'ITEM' ? 'textid' : 'id'] = '';
    },
    addtag: function addtag(data) {
      this.paramsData.context = "".concat(this.paramsData.context).concat(data);
    },
    addDomain: function addDomain() {
      this.paramsData.reward.push({
        num: "",
        type: "",
        id: "",
        textid: "",
        quality: "",
        star: 0,
        ext: ""
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.paramsData.reward.indexOf(item);

      if (index !== -1) {
        this.paramsData.reward.splice(index, 1);
      }
    },
    domainType: function domainType(index, type) {
      this.paramsData.reward[index].id = "";
      this.paramsData.reward[index].textid = "";

      if (this.paramsData.reward[index].num) {
        this.paramsData.reward[index].num = '';
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this7 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this7.$confirm(_this7.$t('confirmSubmit'), _this7.$t('tip'), {
            confirmButtonText: _this7.$t('confirm'),
            cancelButtonText: _this7.$t('cancel'),
            type: "warning",
            beforeClose: function beforeClose(action, instance, done) {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                var data = JSON.parse(JSON.stringify(_this7.paramsData));
                data.server_id = data.server_id.toString();
                data.reward.map(function (item) {
                  item.id = item.id == '' ? item.textid : item.id;
                  delete item.textid;

                  if (!item.quality) {
                    delete item.quality;
                  }

                  if (item.type != 1) {
                    delete item.star;
                  }

                  if (item.type != 1 && item.type != 3 && item.type != 2) {
                    delete item.quality;
                  }

                  if (!(item.type == 3 && item.id >= 1950 && item.id <= 1957)) {
                    delete item.ext;
                  }

                  for (var i in item) {
                    if (i == "ext") {
                      item[i] = [item[i]];
                    } else {
                      item[i] = parseInt(item[i]);
                    }
                  }
                });
                data.delay_time = data.delay_time;
                var uids = data.uids ? data.uids.split(",") : [];
                data.reward = _this7.isPermissions ? "[]" : JSON.stringify(data.reward);

                if (data.type == 'to_users' && data.delay_state == 1) {
                  if (_this7.paramsData.serverData.length > 1) {
                    var d = {};

                    _this7.paramsData.serverData.forEach(function (i) {
                      var uidI = i.value.split(',');
                      uidI = uidI.map(function (i) {
                        return i = parseInt(i);
                      });
                      d[i.label] = uidI;
                    });

                    data.uids = JSON.stringify(d);
                  } else {
                    var uidI = _this7.paramsData.serverData.length && _this7.paramsData.serverData[0].value.split(',') || [];
                    uidI = uidI.map(function (i) {
                      return i = parseInt(i);
                    });
                    data.uids = JSON.stringify(uidI);
                  }
                } else {
                  uids = uids.map(function (i) {
                    return i = parseInt(i);
                  });
                  data.uids = data.uids && data.type == "to_users" ? JSON.stringify(uids) : "";
                }

                data.method = data.id ? "edit" : "add";
                szgmSendEmail(_objectSpread(_objectSpread({}, data), {}, {
                  server_channel: _this7.server_channel,
                  server_show_test: _this7.show_test,
                  env_id: _this7.propsData.env_id,
                  game_id: _this7.rawData.game_id
                })).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(res.code == 200)) {
                              _context3.next = 13;
                              break;
                            }

                            if (!(_this7.isSend && data.delay_state == 2)) {
                              _context3.next = 6;
                              break;
                            }

                            _context3.next = 4;
                            return szgmdoSend(_objectSpread(_objectSpread({}, data), {}, {
                              id: res.data,
                              game_id: _this7.rawData.game_id
                            })).then(function (ress) {
                              if (ress.code == 200) {
                                _this7.$message({
                                  message: _this7.$t('operationSuccess'),
                                  type: "success"
                                });
                              }
                            });

                          case 4:
                            _context3.next = 8;
                            break;

                          case 6:
                            _this7.$message({
                              type: "success",
                              message: _this7.$t('operationSuccess')
                            });

                            _this7.$emit("change");

                          case 8:
                            done();
                            _this7.dialogShow = false;
                            instance.confirmButtonLoading = false;
                            _context3.next = 15;
                            break;

                          case 13:
                            done();
                            instance.confirmButtonLoading = false;

                          case 15:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              } else {
                done();
                instance.confirmButtonLoading = false;
              }
            }
          });
        }
      });
    }
  }
};